import React from 'react';

/* Catches render errors anywhere below it so a single throw can't blank the
   whole live site. Falls back to a small on-brand message. */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('App error boundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.9rem',
            background: '#F2F1EC',
            color: '#1A1814',
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <h1 style={{ fontFamily: 'Fraunces, Georgia, serif', fontWeight: 500, fontSize: '1.7rem', margin: 0 }}>
            Something went wrong.
          </h1>
          <p style={{ color: '#57534B', margin: 0 }}>Try refreshing the page.</p>
          <a
            href="/product"
            style={{ color: '#B2506A', fontFamily: 'monospace', fontSize: '0.8rem', letterSpacing: '0.04em', textDecoration: 'none' }}
          >
            ← Back to work
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
